import {
  type ReferentialEnum,
  referentialEnumToReferentialCodeList,
} from "@pharmupp/p3-front-commons"

export const socialMediaTypesConf = {
  FACEBOOK: { label: "Facebook" },
  INSTAGRAM: { label: "Instagram" },
  GOOGLE_MY_BUSINESS: { label: "Google My Business" },
} as const satisfies ReferentialEnum

export type SocialMediaTypesName = keyof typeof socialMediaTypesConf

export const socialMediaTypesReferential =
  referentialEnumToReferentialCodeList(socialMediaTypesConf)
